import { Pipe, PipeTransform } from '@angular/core';
import { Request } from '../../classes/request';

@Pipe({
  name: 'creationDateFilter',
  pure: false
})
export class CreationDateFilterPipe implements PipeTransform {

  transform(requestList: Array<Request>, dateFrom: string, dateTo: string): any {
    if (!requestList || (!dateFrom && !dateTo)) {
      return requestList;
    }

    return requestList.filter(request => {
      if (!request.CreationDate) {
        return false;
      }

      const creationDate = new Date(request.CreationDate);
      if (isNaN(creationDate.getTime())) {
        return false;
      }

      if (dateFrom) {
        const fromDate = new Date(dateFrom);
        fromDate.setHours(0, 0, 0, 0);
        if (creationDate < fromDate) {
          return false;
        }
      }

      if (dateTo) {
        const toDate = new Date(dateTo);
        toDate.setHours(23, 59, 59, 999);
        if (creationDate > toDate) {
          return false;
        }
      }

      return true;
    });
  }

}
